"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledConversationCard2 = exports.StyledButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _ConversationCard = _interopRequireDefault(require("../ConversationCard2"));
var _iconsReact = require("../../../../icons-react");
var _ChainSkeleton = _interopRequireDefault(require("../ChainSkeleton"));
var _excluded = ["total", "conversations", "onClickCard", "selectedId", "isCreate", "onCreateConversation", "isFetchChainsLoading"],
  _excluded2 = ["id", "unreadMessages", "to"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ConversationList2 = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var total = _ref.total,
    conversations = _ref.conversations,
    onClickCard = _ref.onClickCard,
    selectedId = _ref.selectedId,
    isCreate = _ref.isCreate,
    onCreateConversation = _ref.onCreateConversation,
    isFetchChainsLoading = _ref.isFetchChainsLoading,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var headline = "\u0426\u0435\u043F\u043E\u0447\u043A\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \xB7 ".concat(isFetchChainsLoading ? 'Загрузка...' : total);
  var handleClick = (0, _react.useCallback)(function (_ref2) {
    var currentTarget = _ref2.currentTarget;
    var dataset = currentTarget.dataset;
    var id = dataset.id;
    onClickCard(id);
  }, [onClickCard]);
  var handleCreateConversation = (0, _react.useCallback)(function () {
    onCreateConversation();
  }, [onCreateConversation]);
  return /*#__PURE__*/_react["default"].createElement(StyledConversationList2, props, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, /*#__PURE__*/_react["default"].createElement(StyledHeadLine, null, headline), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onClick: handleCreateConversation
  }, /*#__PURE__*/_react["default"].createElement(StyledCreateConversationIcon, null))), /*#__PURE__*/_react["default"].createElement(StyledContainer, null, /*#__PURE__*/_react["default"].createElement(StyledConversationCard2, {
    isHideCreateConversation: !isCreate,
    isCreateNewConversation: true,
    isSelected: true,
    title: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u0435\u043C\u0443"
  }), conversations && conversations.map(function (_ref3) {
    var id = _ref3.id,
      unreadMessages = _ref3.unreadMessages,
      to = _ref3.to,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(StyledConversationCard2, (0, _extends2["default"])({
      key: id,
      "data-id": id,
      onClick: handleClick,
      unreadAmount: unreadMessages,
      to: to,
      isSelected: id === selectedId
    }, otherProps));
  }), isFetchChainsLoading && !conversations.length && new Array(3).fill(null).map(function (_, idx) {
    return /*#__PURE__*/_react["default"].createElement(StyledChainSkeleton, null);
  })));
});
ConversationList2.displayName = 'ConversationList2';
ConversationList2.propTypes = {
  className: _propTypes["default"].string,
  total: _propTypes["default"].number,
  conversations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    title: _propTypes["default"].string,
    unreadMessages: _propTypes["default"].number
  })),
  selectedId: _propTypes["default"].string,
  isCreate: _propTypes["default"].bool,
  onClickCard: _propTypes["default"].func,
  onCreateConversation: _propTypes["default"].func
};
ConversationList2.defaultProps = {
  className: '',
  total: null,
  conversations: null,
  selectedId: null,
  isCreate: false,
  onClickCard: Function.prototype,
  onCreateConversation: Function.prototype
};
var StyledConversationList2 = _styledComponents["default"].div.withConfig({
  displayName: "ConversationList2__StyledConversationList2",
  componentId: "sc-lfkdea-0"
})(["background-color:transparent;width:300px;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "ConversationList2__StyledTitle",
  componentId: "sc-lfkdea-1"
})(["display:flex;flex-direction:row;height:12px;"]);
var StyledHeadLine = _styledComponents["default"].div.withConfig({
  displayName: "ConversationList2__StyledHeadLine",
  componentId: "sc-lfkdea-2"
})(["width:140px;height:15px;font-size:12px;color:#919499;flex-grow:1;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;"]);
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ConversationList2__StyledButton",
  componentId: "sc-lfkdea-3"
})(["padding:0;border:none;background:none;height:14px;max-width:25px;"]);
var StyledCreateConversationIcon = (0, _styledComponents["default"])(_iconsReact.CreateConversation).withConfig({
  displayName: "ConversationList2__StyledCreateConversationIcon",
  componentId: "sc-lfkdea-4"
})(["width:22px;height:15px;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "ConversationList2__StyledContainer",
  componentId: "sc-lfkdea-5"
})(["margin-top:7px;"]);
var StyledConversationCard2 = exports.StyledConversationCard2 = (0, _styledComponents["default"])(_ConversationCard["default"]).withConfig({
  displayName: "ConversationList2__StyledConversationCard2",
  componentId: "sc-lfkdea-6"
})(["cursor:pointer;transition:height 0.6s ease-in-out,opacity 0.6s ease-in-out;", " ", ""], function (props) {
  return props.isHideCreateConversation && "\n    display: none;\n  ";
}, function (props) {
  return props.isSelected && "\n    box-shadow: 0 10px 15px 0 rgba(196, 194, 182, 0.9), 0 1px 2px 0 rgba(210, 208, 197, 0.9);\n    transition: box-shadow 0.3s ease-in-out;\n    padding-left: 5px;\n    padding-bottom: 10px;\n    border-bottom-left-radius: 4px;\n    border-top-left-radius: 4px;\n    padding-right: 25px;\n    margin-right: -26px;\n    position: relative;\n    background-color: white;\n  ";
});
var StyledChainSkeleton = (0, _styledComponents["default"])(_ChainSkeleton["default"]).withConfig({
  displayName: "ConversationList2__StyledChainSkeleton",
  componentId: "sc-lfkdea-7"
})(["&:first-of-type{margin-top:10px;}"]);
var _default = exports["default"] = ConversationList2;